//frontend/src/services/profileService.js
import apiClient from '../api/apiClient';
import authService from './authService';

/**
 * سرویس مدیریت پروفایل و تعاملات کاربر
 * نسخهٔ نهایی هماهنگ با apiClient
 */

// ۱. اطلاعات کاربری
export const getUserProfile = async () => {
    const response = await apiClient.get('/profile/me/');
    return response.data?.data || response.data;
};

export const updateUserProfile = async (profileData) => {
    const response = await apiClient.patch('/profile/me/', profileData);
    return response.data?.data || response.data;
};

// ۲. محتوای کاربر
export const getWatchedHistory = async (nextPageUrl = null) => {
    try {
        const url = nextPageUrl || '/profile/history/';
        const response = await apiClient.get(url);
        return response.data;
    } catch (error) {
        console.error("Error fetching history:", error);
        return { results: [], next: null };
    }
};

export const getFavoriteProducts = async (nextPageUrl = null) => {
    const url = nextPageUrl || '/profile/favorites/';
    const response = await apiClient.get(url);
    return response.data;
};

// ۳. تعاملات محصول
export const toggleProductLike = async (productId) => {
    const response = await apiClient.post(`/products/${productId}/toggle-like/`);
    return response.data; 
};

export const updatePlaybackPosition = async (mediaId, positionSec) => {
    const response = await apiClient.post('/products/user/history/update/', {
        media_id: mediaId,
        position_sec: positionSec
    });
    return response.data;
};

// ۴. سایر خدمات
export const getDailyMessage = async () => {
    const response = await apiClient.get('/profile/daily-message/');
    return response.data?.data || response.data; 
};

export const submitVolunteerApplication = async (applicationData) => {
    const response = await apiClient.post('/profile/volunteer-application/', applicationData);
    return response.data;
};

// ۵. دعوت از دوستان
export const getReferralCode = async () => {
    const response = await apiClient.get('/profile/referral/code/');
    return response.data;
};

export const getReferredUsers = async (nextPageUrl = null) => {
    const url = nextPageUrl || '/profile/referral/referred-users/';
    const response = await apiClient.get(url);
    return response.data;
};

// ۶. شیء پیش‌فرض برای صادرات
const profileService = {
    getUserProfile,
    updateUserProfile,
    getWatchedHistory,
    getFavoriteProducts,
    toggleProductLike,
    updatePlaybackPosition,
    getDailyMessage,
    submitVolunteerApplication,
    getReferralCode,
    getReferredUsers,
    auth: authService
};

export default profileService;